import 'babel-polyfill';
import VueRouter from 'vue-router';
import routerConfig from './router/router.js';
import axios from 'axios';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import MtaH5 from 'Libs/mta.js';
import App from './app';
import store from 'Stores';
import qs from 'qs';
import { SAVE_ROUTER } from 'Stores/mutation-types.js';
import Vue from 'vue';
import common from 'Assets/js/common.js';
import accounting from 'Assets/vendor/account/accounting.min.js';
import 'Libs/element-ui/config';
import TglUi from '@tencent/tgl-ui';
import '@tencent/tgl-ui/lib/tgl-ui.css';
import * as filters from 'Libs/filters.js';
import './registerServiceWorker';

// import { registerMicroApps, start } from 'qiankun';
// registerMicroApps([
//     {
//         name: 'activity/material',
//         entry: '//ctp.qq.com',
//         has: 'eeee',
//         container: '#material-frame',
//         activeRule: '/activity/material',
//     },
// ]);
// 启动 qiankun
// start();

// 开启调试面板
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$common = common;
Vue.use(VueRouter);
Vue.use(TglUi);
window.domain = 'qq.com';
document.domain = 'qq.com';
// 开启sentry js 异常上报
if (location.origin == 'https://tgl.qq.com') {
    try {
        Raven.config(
            'https://05ba0d3e1bbb4bd38c7cac8a5900b2ff@report.url.cn/sentry/123',
            {
                maxBreadcrumbs: 20,
                release: 'sentryRelease',
            }
        )
            .addPlugin(RavenVue, Vue)
            .install();
    } catch (e) {}
}
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]));
var router = new VueRouter(routerConfig);
router.beforeEach(async (to, from, next) => {
    // 组件式云剪免登录
    if (to.name === 'center-cme-editComponent') {
        next();
        return;
    }
    store.commit('setReportNum');
    //未匹配则调到首页
    if (to.matched.length == 0) {
        location.href = `${document.location.protocol}//${document.location.hostname}`;
        return;
    }
    store.commit(SAVE_ROUTER, to);
    //登录判断
    if (!store.state.status.login && !to.meta.alone) {
        await store.dispatch({
            type: 'getUserInfo',
        });
        await store.dispatch({
            type: 'getNotice',
        });

        await store.dispatch({
            type: 'getAuth',
        });

        if (to.meta.isActivity) {
            await store.dispatch({
                type: 'getUserBrief',
            });
            await store.dispatch({
                type: 'getUserActivityAuth',
                sig: to.params.id,
            });
            //获取用户媒体账号
            store.dispatch({
                type: 'getUserMediaAccounts',
            });
        }
    }

    if (
        store.state.realUserInfo.authorType == 40 &&
        to.name != 'v4-set-account'
    ) {
        Vue.prototype.$alert('认证信息被驳回，请重新提交', '提示', {
            confirmButtonText: '确定',
        });
        return next({
            name: 'v4-set-account',
        });
    }

    //设置页面标题
    if (to.matched.length > 0 && to.meta.title != undefined) {
        document.title = to.meta.title;
    }
    //统计pv
    if (to.matched.length > 0 && location.origin == 'https://tgl.qq.com') {
        MtaH5.pgv();
        MtaH5.clickStat('userinfo', {
            account:
                store.state.realUserInfo.qq || store.state.realUserInfo.openid,
            pathname: location.href,
        });
        if (location.href.includes('/center/activity')) {
            MtaH5.clickStat('notice', {
                account:
                    store.state.realUserInfo.qq ||
                    store.state.realUserInfo.openid,
                pathname: location.hash.slice(18),
                link: `${store.state.realUserInfo.qq ||
                    store.state.realUserInfo.openid}+${location.hash.slice(
                    18
                )}`,
            });
        }
        if (location.href.includes('/notice/detail')) {
            MtaH5.clickStat('notice', {
                account:
                    store.state.realUserInfo.qq ||
                    store.state.realUserInfo.openid,
                pathname: location.hash.slice(23),
                link: `${store.state.realUserInfo.qq ||
                    store.state.realUserInfo.openid}+${location.hash.slice(
                    23
                )}`,
            });
        }
    }
    next();
});

Vue.filter('moneyFormat', (value, fixed = 2) => {
    return accounting.formatNumber(value, fixed);
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
